var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"g-wrapper"},[_c('div',{staticClass:"g-main-wrapper"},[_c('ElTabs',{on:{"tab-click":_vm.changeRouter},model:{value:(_vm.currentRoute),callback:function ($$v) {_vm.currentRoute=$$v},expression:"currentRoute"}},[_vm._t("default")],2),_c('keep-alive',{attrs:{"max":10}},[_c('router-view',{key:_vm.$route.path})],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }